import { isDefined, isIsoDate, isNumberRange, isIdentifier } from "@perxis-auto/shared";
const prepareRequestFilters = (filters) => {
  const preparedFilters = Object.entries(filters).reduce((acc, [key, value]) => {
    if (!isDefined(value)) {
      return acc;
    }
    const filterValue = Array.isArray(value) ? value : [value];
    if (!value.length) {
      return acc;
    }
    if (isIsoDate(filterValue[0])) {
      return [...acc, `${key} in [Time.Time("${filterValue.join('"), Time.Time("')}")]`];
    }
    if (isNumberRange(filterValue)) {
      return [...acc, `${key} >= ${filterValue[0]} && ${key} <= ${filterValue[1]}`];
    }
    if (isIdentifier(filterValue[0])) {
      return [...acc, `${key}.id in ["${filterValue.join('", "')}"]`];
    }
    return [...acc, `${key} in ["${filterValue.join('", "')}"]`];
  }, []);
  return preparedFilters;
};
export {
  prepareRequestFilters
};
